import { CompanyConstant } from "presentation/constant/Company/CompanyConstant";
import { useCompanyDetailVM } from "presentation/hook/Company/useCompanyDetailVM";
import { useCompanyDockageVM } from "presentation/hook/Company/useCompanyDockageVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";

import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHCheckbox, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const CompanyDockageFormPanel = () => {
    const [companyDtlState] = useCompanyDetailTracked();
    const companyDockageVM = useCompanyDockageVM();
    const companyDtlVM = useCompanyDetailVM();
    const messageBarVM = useMessageBarVM();

    const COMPANY_DTL_CONST = CompanyConstant.Detail;
    const [isLoading, setIsLoading] = useState(false);
    const { dynamicOptions } = companyDtlState
    const { isAdd, isEditable, isEditCompDtlInfo, allFormState } = companyDtlState.viewState
    const { currentCompDockage } = companyDtlState.companyDockageState

    useEffect(() => {
        if (companyDtlState.viewState.isShowDockage) {
            setIsLoading(true);
            companyDockageVM.loadDropdownOption().then(data => {
                companyDockageVM.onInitDefaultValue();
            });
            setIsLoading(false);
        }
    }, [companyDtlState.isShowRightPanel, companyDtlState.viewState.isShowDockage, companyDockageVM]);

    const handleCancelClick = useCallback(() => {
        companyDtlVM.onCancel();
    }, [companyDtlVM])

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        companyDockageVM.onFieldChange(fieldName, fieldValue);
    }, [companyDockageVM]);

    const handleSaveClick = useCallback(() => {
        if (currentCompDockage.hoursInTier === null ||
            currentCompDockage?.hoursInTier < 0 || currentCompDockage?.hoursInTier > 1000) {
            messageBarVM.showError('Input Value should be range from 0 to 10,000.');
            return;
        }
        setIsLoading(true);
        currentCompDockage.companyId = companyDtlState.companyId;
        companyDockageVM.onSave(currentCompDockage).then((data) => {
            if (data && data["saveCompDockageFailed"]) {
                setIsLoading(false);
                messageBarVM.showError(data["saveCompDockageFailed"]?.toString());
                return;
            }
            companyDtlState.companyId && companyDockageVM.initialDockageTableData(companyDtlState.companyId).then(() => {
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
            });
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Save Data Failed.');
        });
    }, [companyDtlState.companyId, companyDockageVM, messageBarVM, currentCompDockage])

    const memoTier = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "245px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                //isReadOnly={isDisabled()}
                isShowOptional={false}
                isMultipleDropDown={false}
                disabled={!isEditCompDtlInfo || isEditable}
                readOnlyValue={currentCompDockage?.tier ?? ''}
                fieldValue={currentCompDockage?.tier ?? ''}
                fieldLabel={COMPANY_DTL_CONST.DOCKAGE.TIER}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tier'}
                options={dynamicOptions.tierDropdownOptions}
                maxLength={60}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyDockageVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_DTL_CONST.DOCKAGE.TIER, allFormState, companyDockageVM, currentCompDockage?.tier, dynamicOptions.tierDropdownOptions, isEditCompDtlInfo, isEditable])



    const memoHoursInTier = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={COMPANY_DTL_CONST.DOCKAGE.HOURS_IN_TIER}
                maxLength={10}
                width="180px"
                fieldName={"hoursInTier"}
                value={currentCompDockage?.hoursInTier ?? ''}
                errorMessage={""}
                disabled={!isEditCompDtlInfo || isEditable}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMPANY_DTL_CONST.DOCKAGE.HOURS_IN_TIER, currentCompDockage?.hoursInTier, isEditCompDtlInfo, isEditable, onNumberFieldChange])


    const memoCalculatedByHours = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"calculatedByHours"}
                requiredFieldList={[]}
                fieldLabel={COMPANY_DTL_CONST.DOCKAGE.CALCULATED_BY_HOURS}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                errorMessages={allFormState}
                label={''}
                checked={currentCompDockage?.calculatedByHours === 'Y' ? true : false}
                disabled={!isEditCompDtlInfo || isEditable}
                onChange={(e) => companyDockageVM.onCheckboxChange(e.checked, "calculatedByHours")} />
        </div>
        , [COMPANY_DTL_CONST.DOCKAGE.CALCULATED_BY_HOURS, allFormState, companyDockageVM, currentCompDockage?.calculatedByHours, isEditCompDtlInfo, isEditable])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{'DOCKAGE'}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        <CriteriaItemContainer>
                            {memoTier}
                            {memoHoursInTier}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCalculatedByHours}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>

            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={(!isAdd) ? 'Close' : 'Cancel'} size={'Small'} theme={'Secondary'} onClick={() => handleCancelClick()} />
                        {(isAdd || isEditable) && <HPHButton label={isAdd ? 'Add' : isEditable ? 'Update' : 'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />}
                    </>
                }
            </div>

        </div>
    )
}
export default memo(CompanyDockageFormPanel);